import { INBOX_TYPES } from 'dashboard/helper/inbox';

export const normalizePhoneDisplay = phone => {
  if (!phone) return '';
  let normalized = String(phone).replace(/^\+/, '');
  if (normalized.startsWith('549')) normalized = normalized.slice(3);
  return normalized;
};

const formatUsername = username => {
  if (!username) return '';
  return username.startsWith('@') ? username : `@${username}`;
};

const getAdditionalAttributes = contact => {
  return contact?.additional_attributes || contact?.additionalAttributes || {};
};

const getSocialProfiles = contact => {
  const attrs = getAdditionalAttributes(contact);
  return attrs.social_profiles || attrs.socialProfiles || {};
};

const getPhoneHandle = contact => {
  const phone = contact?.phone_number || contact?.phoneNumber || '';
  return normalizePhoneDisplay(phone);
};

const getTelegramHandle = contact => {
  const attrs = getAdditionalAttributes(contact);
  const socialProfiles = getSocialProfiles(contact);
  const telegram =
    socialProfiles.telegram ||
    attrs.social_telegram_user_name ||
    attrs.socialTelegramUserName ||
    '';
  return formatUsername(telegram);
};

const getTwitterHandle = contact => {
  const attrs = getAdditionalAttributes(contact);
  const socialProfiles = getSocialProfiles(contact);
  const twitter =
    socialProfiles.twitter || attrs.screen_name || attrs.screenName || '';
  return formatUsername(twitter);
};

const getInstagramHandle = contact => {
  const socialProfiles = getSocialProfiles(contact);
  const instagram = socialProfiles.instagram || '';
  return formatUsername(instagram);
};

const getFallbackHandle = contact => {
  const phone = getPhoneHandle(contact);
  if (phone) return phone;

  const email = contact?.email || '';
  if (email) return email;

  const identifier = contact?.identifier || '';
  if (identifier) return identifier;

  const telegram = getTelegramHandle(contact);
  if (telegram) return telegram;

  const twitter = getTwitterHandle(contact);
  if (twitter) return twitter;

  const instagram = getInstagramHandle(contact);
  if (instagram) return instagram;

  return '';
};

export const getContactHandle = (contact, channelType) => {
  if (!contact) return '';

  switch (channelType) {
    case INBOX_TYPES.EMAIL:
      return contact.email || '';
    case INBOX_TYPES.WHATSAPP:
    case INBOX_TYPES.TWILIO:
    case INBOX_TYPES.SMS:
      return getPhoneHandle(contact);
    case INBOX_TYPES.TELEGRAM:
      return getTelegramHandle(contact);
    case INBOX_TYPES.TWITTER:
      return getTwitterHandle(contact);
    case INBOX_TYPES.INSTAGRAM:
      return getInstagramHandle(contact) || contact.identifier || '';
    default:
      return getFallbackHandle(contact);
  }
};
